'use client';

import { DatePicker } from '@koda/koda-components/molecules/DatePicker';
import NumberField from '@koda/koda-components/molecules/NumberField';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { ReactElement } from 'react';
import { LicenseTypes } from '../../../types/licenses';
import { useLicenseBusiness } from '../hooks/useLicenseBusiness';
import { COMPANY_PARTY_CONTENT_PATH, companyPartySchema, createCompanyPartyDefaults } from './companyParty.Schema';
import { Past5Years } from './consts/dateIntervals';

export default function CompanyPartyComponent(): ReactElement {
  const licenseCode = LicenseTypes.CompanyParty;
  const { values, setField, getError, costCalculated, showErrors } = useLicenseBusiness(licenseCode, {
    schema: companyPartySchema,
    defaults: createCompanyPartyDefaults,
  });

  const t = useTranslations(COMPANY_PARTY_CONTENT_PATH);

  return (
    <>
      <DatePicker
        label={t('eventDate.label')}
        name="eventDate"
        placeholder={t('eventDate.placeholder')}
        disabled={costCalculated}
        value={values.eventDate && values.eventDate !== '' ? new Date(values.eventDate) : undefined}
        onChange={date => setField('eventDate', date ? dayjs(date).format('YYYY-MM-DD') : '')}
        error={values.eventDate || showErrors ? getError('eventDate') : undefined}
        validated={!!values.eventDate && !getError('eventDate')}
        initialVisibleValue={new Date()}
        interval={Past5Years}
      />
      <NumberField
        label={t('participantCount.label')}
        name="participantCount"
        placeholder={t('participantCount.placeholder')}
        formatThousands
        disabled={costCalculated}
        value={values.participantCount}
        onChange={e => setField('participantCount', parseInt(e.target.value))}
        error={values.participantCount || showErrors ? getError('participantCount') : undefined}
        validated={!!values.participantCount && !getError('participantCount')}
        min={1}
        sign="positive-only"
        styleVariant="border"
      />
    </>
  );
}
